import { captureException } from '@sentry/browser'
import Column from '@/vue-prop-types/DataTable/Column'
import Row from '@/vue-prop-types/DataTable/Row'

/**
 * This works as a simple type setup where we automatically ensure all the data given is in the correct format so that
 * it is ready to be used by a Data table.
 *
 * TODO: When we switch to typescript this class should/could be replaced by and interface or similar
 */
export default class TableDataHandler {
  _columns: Column[]
  _rows: Row[]

  get columns() {
    return this._columns || []
  }

  get rows() {
    return this._rows || []
  }

  constructor(data) {
    // We check if this is valid data that we receive
    if (data.columns instanceof Array && data.rows instanceof Array) {
      this._columns = data.columns.map((col) => new Column(col))
      this._rows = data.rows.map((row) => new Row(row))
    } else {
      const e = new Error(
        'TableDataHandler: data in constructor does not contain columns and or rows. Or it contains less than 1 column',
      )
      captureException(e)
      throw e
    }
  }
}
